var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVariant10 = function SvgIconVariant10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.957 5.207a1 1 0 0 0-1.414-1.414l-7.5 7.5a1 1 0 0 0 0 1.414l7.5 7.5a1 1 0 0 0 1.414-1.414L5.164 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.457 5.207a1 1 0 0 0-1.414-1.414l-7.5 7.5a1 1 0 0 0 0 1.414l7.5 7.5a1 1 0 0 0 1.414-1.414L12.664 12z"
  }))));
};
export default SvgIconVariant10;